import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import { PropertyListingService } from '../../../../../shared/providers/property-listing.service';
import { result } from '../../../../../shared/models/OfferComparisonList';
//import { Chart } from 'angular-highcharts';

@Component({
  selector: 'app-leads-conversion',
  templateUrl: './leads-conversion.component.html',
  styleUrls: ['./leads-conversion.component.css']
})
export class LeadsConversionComponent implements OnInit {
    @Input() propertyId = 0;
    @Input() isFromPortfolio: boolean = false;
    constructor(private propertyListing: PropertyListingService) { }
    chart: any;
    result: result[] = [];
    //Chart = new Chart();
    period = 3;
    ngOnInit() {
        this.LoadChart();
  }
    LoadChart() {
        this.propertyListing.GetLeadsCoversionRatio(this.propertyId, this.period).subscribe(res => {
            this.result = res;
            
            this.bindChart();
            });
        
        };

    periodChange() {
        this.LoadChart();
    }

    bindChart() {
        
        const chartData = [];
        const chartXData = [];
        //this.chart = new Chart();
        let chartCount = 0;
        this.result.forEach(item => {
            const serieData = {
                name: item.Name,
              y: isNaN(item.Value) ? 0 : item.Value,
              color: this.getChartColor(item.Name)
            }
            chartData.push(serieData);
            chartXData.push(item.Name);
            chartCount++;

        });



      Highcharts.chart('containerdata', {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}:<b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,

              format: '{point.percentage:.1f} %',
              distance: -50,
            },
            showInLegend: true
          }
        },
        series: [{
          type: undefined,
          innerSize: "0%",
          name: 'Ratio',
          data: chartData
        }],
      });

  }

  getChartColor(name) {
    const colors = [' #003A5D ', ' #198FDE ', ' #59595B ', ' #A7A8A9 ', ' #FFC32B ', ' #02C29F ', ' #bc76b4 ', ' #2b7093 ', ' #FF4438 ']
    if (name == 'Cap Rate') {
      return colors[0];
    }
    else if (name == 'Deal Size') {
      return colors[1];
    }
    else if (name == 'Lease Structure') {
      return colors[2];
    }
    else if (name == 'Location') {
      return colors[3];
    }
    else if (name == 'Credit') {
      return colors[4];
    }
    else if (name == 'Term') {
      return colors[5];
    }
    else if (name == 'Debt') {
      return colors[6];
    }
    else if (name == 'Tenant') {
      return colors[7];
    }
    else if (name == 'Other') {
      return colors[8];
    }

  //getChartColor(index) {
  //  const colors = [' #6596D6 ', ' #67A7FA ', ' #1967CB ', ' #0D77FF ', ' #004298 ', ' #285CA1 ', ' #55759E ', ' #4788DC ', ' #5167EA ', ' #2B44D8 ', ' #7582CF ', ' #4354B9 ', ' #0F24A4 ', ' #1458E2 ', ' #3562BF ', ' #305297 ', ' #333286 ', ' #98C7FF ', ' #4886D8 ', ' #2C99D7 ', ' #157BB5 ', ' #0C6699 ', ' #49A1D3 ', ' #62BFF3 ', ' #51B5D1 ', ' #6186D3 ', ' #33C5DF ', ' #21A5BC ', ' #277583 ', ' #274183 ', ' #21459E ', ' #4674E6 ', ' #3355AA ', ' #596C9C ', ' #503C8D ', ' #6042BE ', ' #906CFF ', ' #B08CC8 ', ' #A374AE ', ' #B4658E ', ' #CA62DF ', ' #A264D9 ', ' #90B36C ', ' #6C963D ', ' #6AB16A ', ' #75D285 ', ' #B3BB66 ', ' #C77272 ', ' #D75555 ', ' #A34646 ']
  //  return colors[index];
  }
}
